import Isotope from 'isotope-layout';
import Packery from 'isotope-packery';

document.addEventListener('DOMContentLoaded', function () {
    const projectWall = document.querySelector('.wp-block-ahoy-project-wall');

    if (!projectWall) {
        return;
    }

    new Isotope(projectWall, {
        itemSelector: '.wp-block-ahoy-project-wall__item',
        percentPosition: true,
        layoutMode: 'packery',
        packery: {
            columnWidth: '.wp-block-ahoy-project-wall__sizer'
        },
        sortBy: 'random'
    });
});